import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChangeIconPageComponent } from './change-icon.page';

const routes: Routes = [
  {
    component: ChangeIconPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ChangeIconPageRoutingModule {}
